module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4f9a17534c29f3e40970aa45d92f4ebb.png";